import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Carousel, Col, Container, Image, Row } from "react-bootstrap";

export const Reviews = () => {
  return (
    <Container fluid className="reviews-section">
      <Container>
        <Row>
          <Col data-aos="fade-left">
            <h2>Testimonials</h2>
            <div className="underline"></div>
          </Col>
        </Row>
        <Row>
          <Col>
            <h3 data-aos="fade-right">What People Are Saying</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <Carousel fade data-aos="fade-right">
              <Carousel.Item>
                <Image
                  src="https://images.unsplash.com/photo-1506863530036-1efeddceb993?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1044&q=80"
                  alt="Reviewer One Image"
                />
                <p className="text-center w-50 d-block margin-left-right-auto mt-5 mb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  nec maximus lorem, volutpat efficitur metus. Vestibulum ante
                  ipsum primis in faucibus orci luctus et ultrices posuere
                  cubilia curae; Mauris lobortis scelerisque aliquam. Aenean
                  congue enim sit amet sem euismod aliquet.
                </p>
                <div className="d-flex flex-row text-center justify-content-center mt-4">
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                </div>
                <h4 className="text-center">Reviewer One</h4>
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  src="https://images.unsplash.com/photo-1564564321837-a57b7070ac4f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1176&q=80"
                  alt="Reviewer Two Image"
                />
                <p className="text-center w-50 d-block margin-left-right-auto mt-5 mb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  nec maximus lorem, volutpat efficitur metus. Vestibulum ante
                  ipsum primis in faucibus orci luctus et ultrices posuere
                  cubilia curae; Mauris lobortis scelerisque aliquam. Aenean
                  congue enim sit amet sem euismod aliquet.
                </p>
                <div className="d-flex flex-row text-center justify-content-center mt-4">
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                </div>
                <h4 className="text-center">Reviewer Two</h4>
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  src="https://images.unsplash.com/photo-1593104547489-5cfb3839a3b5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1153&q=80"
                  alt="Reviewer Three Image"
                />
                <p className="text-center w-50 d-block margin-left-right-auto mt-5 mb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  nec maximus lorem, volutpat efficitur metus. Vestibulum ante
                  ipsum primis in faucibus orci luctus et ultrices posuere
                  cubilia curae; Mauris lobortis scelerisque aliquam. Aenean
                  congue enim sit amet sem euismod aliquet.
                </p>
                <div className="d-flex flex-row text-center justify-content-center mt-4">
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                </div>
                <h4 className="text-center">Reviewer Three</h4>
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  src="https://images.unsplash.com/photo-1474176857210-7287d38d27c6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                  alt="Reviewer Four Image"
                />
                <p className="text-center w-50 d-block margin-left-right-auto mt-5 mb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  nec maximus lorem, volutpat efficitur metus. Vestibulum ante
                  ipsum primis in faucibus orci luctus et ultrices posuere
                  cubilia curae; Mauris lobortis scelerisque aliquam. Aenean
                  congue enim sit amet sem euismod aliquet.
                </p>
                <div className="d-flex flex-row text-center justify-content-center mt-4">
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                  <FontAwesomeIcon icon={faStar} color="gold" />
                </div>
                <h4 className="text-center">Reviewer Four</h4>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
